module.exports = __webpack_public_path__ + "img/background_img.d1c247d1.png";